<script lang="ts" setup>
import type { IMainTitle } from '~/shared/interfaces/ui/title/mainTitle'
import useMainStore from "~/shared/store";
withDefaults(defineProps<IMainTitle>(),{
  size:'m',
})
const mainStore = useMainStore()
</script>

<template>
  <div :class="!mainStore.titleH1 && textWithSeo && 'main-title__row'">
    <h1
      class="main-title"
      :class="[`main-title_${size}`]"
    >
      {{ mainStore.titleH1 || text }}
    </h1>
    <div class="main-title__subtitle">
      <p v-if="mainStore.titleH1 && textWithSeo">{{ text }}</p>
      <slot />
    </div>
  </div>
</template>

<style  lang="scss" scoped>
.main-title {
  word-wrap: break-word;
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
    @include md-breakpoint {
      gap: 8px;
      flex-direction: column;
      align-items: start;
    }
  }
  &__subtitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      @include font(14px, 20px, 400);
      color: $content_secondary;
    }
    @include md-breakpoint {
      flex-direction: column;
      align-items: start;
    }
  }

  &_l {
    @include font(40px, 48px, 700);
  }
  &_m {
    @include font(36px, 44px, 700);
    @include md-breakpoint {
      @include font(28px, 32px, 600);
    }
  }
  &_s {
    @include font(28px, 32px, 600);
  }
  &_xs {
    @include font(24px, 28px, 600);
  }
}
</style>
